import contentSettings from '@site/content.settings'

import { runWhenCookiebotConsentGranted } from '~/app/cookiebot'

const TRUSTED_SHOPS_TSID = 'X856232252D9B7DBCB3C6B44219660619'
const TRUSTED_SHOPS_SCRIPT_SRC = `https://widgets.trustedshops.com/js/${TRUSTED_SHOPS_TSID}.js`
const TRUSTED_SHOPS_CHECKOUT_BLOCK_ID = 'trustedShopsCheckout'
const TRUSTED_SHOPS_CONSENT_CATEGORIES = ['marketing']

const TRUSTED_SHOPS_SCRIPT_ATTRIBUTES = {
  'data-desktop-y-offset': '0',
  'data-mobile-y-offset': '0',
  'data-desktop-disable-reviews': 'false',
  'data-desktop-enable-custom': 'false',
  'data-desktop-position': 'right',
  'data-desktop-custom-width': '156',
  'data-desktop-enable-fadeout': 'false',
  'data-disable-mobile': 'false',
  'data-disable-trustbadge': 'false',
  'data-mobile-custom-width': '156',
  'data-mobile-disable-reviews': 'false',
  'data-mobile-enable-custom': 'false',
  'data-mobile-position': 'left',
  'data-mobile-enable-topbar': 'false',
  'data-mobile-enable-fadeout': 'true',
  'data-color-scheme': 'light',
}

function runWhenBodyReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true })
    return
  }

  callback()
}

function setScriptAttributes(script) {
  Object.keys(TRUSTED_SHOPS_SCRIPT_ATTRIBUTES).forEach(attributeName => {
    script.setAttribute(attributeName, TRUSTED_SHOPS_SCRIPT_ATTRIBUTES[attributeName])
  })
}

function removeTrustbadgeScripts() {
  document.querySelectorAll('script[src*="widgets.trustedshops.com/js/"]').forEach(item => item.remove())
}

function removeTrustbadgeFramesAndAssets() {
  document
    .querySelectorAll(
      'iframe[src*="trustedshops.com"], iframe[src*="etrusted.com"], script[src*="assets/trustbadge.js"]',
    )
    .forEach(item => item.remove())
}

function injectTrustbadgeScript(options = {}) {
  const force = !!options.force

  if (force) {
    removeTrustbadgeScripts()
  } else if (document.querySelector(`script[src*="widgets.trustedshops.com/js/${TRUSTED_SHOPS_TSID}.js"]`)) {
    return
  }

  const script = document.createElement('script')
  script.async = true
  script.charset = 'UTF-8'
  script.src = TRUSTED_SHOPS_SCRIPT_SRC
  setScriptAttributes(script)
  document.body.appendChild(script)
}

function refreshTrustbadgeOnCheckoutFinish() {
  if (!document.getElementById(TRUSTED_SHOPS_CHECKOUT_BLOCK_ID)) {
    return
  }

  removeTrustbadgeFramesAndAssets()
  injectTrustbadgeScript({ force: true })
}

export default function({ app }) {
  runWhenCookiebotConsentGranted(contentSettings, TRUSTED_SHOPS_CONSENT_CATEGORIES, () => {
    runWhenBodyReady(() => {
      injectTrustbadgeScript()
    })

    window.addEventListener('trustedshops:checkout-data-ready', () => {
      refreshTrustbadgeOnCheckoutFinish()
    })

    if (!app || !app.router) {
      return
    }

    app.router.afterEach(to => {
      if (!to || !to.name || !String(to.name).includes('checkout-finished')) {
        return
      }

      window.setTimeout(() => {
        refreshTrustbadgeOnCheckoutFinish()
      }, 400)
    })
  })
}
